import React, { useEffect, useState } from 'react';
import '../Css_files/Enroll.css';

const EnrollForm = ({ onClose }) => {
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    mobile: '',
    email: '',
    course: '',
    message: ''
  });

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Clear error when user starts typing
    if (error) {
      setError('');
    }
  };

  const validateForm = () => {
    const { firstName, lastName, mobile, email, course } = formData;

    if (!firstName.trim()) return 'First name is required';
    if (!lastName.trim()) return 'Last name is required';
    if (!mobile.trim()) return 'Mobile number is required';
    if (!email.trim()) return 'Email is required';
    if (!course) return 'Please select a course';

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) return 'Please enter a valid email address';

    // Basic mobile validation (10 digits)
    const mobileRegex = /^[0-9]{10}$/;
    if (!mobileRegex.test(mobile.replace(/\D/g, ''))) return 'Please enter a valid 10-digit mobile number';

    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);

    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      setLoading(false);
      return;
    }

    const data = {
      access_key: '44e66b8b-faf0-4800-bb72-cd3b60680452',
      subject: `New Form From Profenaa Technology - ${formData.course}`,
      name: `${formData.firstName} ${formData.lastName}`,
      email: formData.email,
      mobile: formData.mobile,
      course: formData.course,
      message: formData.message || 'No additional message provided.',
    };

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      if (result.success) {
        setSuccess(true);
        setFormData({
          firstName: '',
          lastName: '',
          mobile: '',
          email: '',
          course: '',
          message: ''
        });
      } else {
        setError("Submission failed. Please try again.");
      }
    } catch (error) {
      console.error("Web3Forms error:", error);
      setError("Network error. Please check your connection and try again.");
    } finally {
      setLoading(false);
    }
  };

  const getFieldClass = (fieldName) => {
    if (error && !formData[fieldName]) return 'form-group has-error';
    if (formData[fieldName]) return 'form-group has-success';
    return 'form-group';
  };

  return (
    <div className="enroll-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="enroll-form-container">
        <button className="close-icon" onClick={onClose}>×</button>
        <h2>Enroll now</h2>

        {success ? (
          <div className="success-message">
            <div className="success-icon">✓</div>
            <h3>Enrollment Successful!</h3>
            <p>Thank you for choosing Profenaa Technologies. We'll contact you shortly with course details and next steps.</p>
            <button className="success-close-btn" onClick={onClose}>Continue</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className={getFieldClass('firstName')}>
              <input
                type="text"
                id="firstName"
                name="firstName"
                value={formData.firstName}
                onChange={handleInputChange}
                placeholder="First Name"
                required
              />
            </div>

            <div className={getFieldClass('lastName')}>
              <input
                type="text"
                id="lastName"
                name="lastName"
                value={formData.lastName}
                onChange={handleInputChange}
                placeholder="Last Name"
                required
              />
            </div>

            <div className={getFieldClass('mobile')}>
              <input
                type="tel"
                id="mobile"
                name="mobile"
                value={formData.mobile}
                onChange={handleInputChange}
                placeholder="Phone Number"
                required
              />
            </div>

            <div className={getFieldClass('email')}>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Email"
                required
              />
            </div>

            <div className={getFieldClass('course')}>
              <select
                id="course"
                name="course"
                value={formData.course}
                onChange={handleInputChange}
                required
              >
                <option value="">Select a Program</option>
                <option value="Mechanical Engineering">Mechanical Engineering</option>
                <option value="Civil Engineering">Civil Engineering</option>
                <option value="Electronics & Communication">Electronics & Communication</option>
                <option value="Electrical Engineering">Electrical Engineering</option>
                <option value="Arts & Multimedia">Arts & Multimedia</option>
                <option value="Computer Science">Computer Science</option>
                <option value="Information Technology">Information Technology</option>
                <option value="Data Science">Data Science</option>
              </select>
            </div>

            <div className="form-group">
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                placeholder="Additional Message"
                rows="3"
              />
            </div>

            {error && <p className="error-text">{error}</p>}
            
            <div className="form-buttons">
              <button 
                type="submit" 
                className={`register-btn ${loading ? 'loading-btn' : ''}`}
                disabled={loading}
              >
                {loading ? 'Processing...' : 'Join Us'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default EnrollForm;